import React, { Component, PropTypes } from 'react';
import ThemeColorRow from './ColorRow';

class ThemeColorPanel extends Component {
    render() {
        return (
            <div id={this.props.id} className="col-xs-12">
                <h4>{this.props.headline}</h4>
                <p className="normal-text">{this.props.subheader}</p>
                <div className="row ThemeColorPanelRow">
                    {this.props.panel === 'primary' &&
                        this.props.colors.map((colorInfo, idx) => {
                            return (
                                <ThemeColorRow
                                    isDisabled={this.props.isDisabled}
                                    panel={this.props.panel}
                                    color={colorInfo.color}
                                    onColorChange={this.props.onColorChange}
                                    id={`${this.props.id}-color-row-${idx}`}
                                    label={colorInfo.label}
                                    idx={idx}
                                    key={colorInfo.label}
                                    messageType={this.props.messageType}
                                />
                            );
                        })}
                </div>
            </div>
        );
    }
}

ThemeColorPanel.propTypes = {
    colors: PropTypes.array,
    headline: PropTypes.string,
    subheader: PropTypes.string,
    panel: PropTypes.string,
    id: PropTypes.string,
    onColorChange: PropTypes.func
};

export default ThemeColorPanel;



// WEBPACK FOOTER //
// ./src/components/pages/theme/colors/ColorPanel.js